export default __webpack_public_path__ + "static/media/14-bottom.256cfd00.png";